import { render, staticRenderFns } from "./eventflow.vue?vue&type=template&id=4e6a4ad7&scoped=true&"
import script from "./eventflow.vue?vue&type=script&lang=js&"
export * from "./eventflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6a4ad7",
  null
  
)

export default component.exports